export default __webpack_public_path__ + "static/media/icon-radio-circle.f9eab2f3.svg";